import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export function Footer() {
  return (
    <footer className={styles.footer}>
      <nav className={styles.links} aria-label="Footer links">
        <Link to="/cookie-policy">Cookie Policy</Link>
        <Link to="/privacy">Privacy Notice</Link>
      </nav>
      <p className={styles.copyright}>
        &copy; {new Date().getFullYear()} Chemical Dependency Lab
      </p>
    </footer>
  );
}
